import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

export type CardInlineMutationSkeletonVariant =
  | 'single'
  | 'two-line'
  | 'amount'
  | 'checkbox'
  | 'switch'
  | 'block'
  | 'table-cell';

@Component({
  selector: 'crm-card-inline-mutation-skeleton-v2',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './card-inline-mutation-skeleton-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardInlineMutationSkeletonV2Component {
  @Input() public variant: CardInlineMutationSkeletonVariant = 'single';
  @Input() public width = '8rem';
  @Input() public amountSecondaryLine = false;
}
